// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"20fdc58c","453":"d5d6ff5d","455":"12dbf519","977":"104ea905"}[chunkId] + ".chunk.js";
};